import {createFileRoute} from '@tanstack/react-router';
import ClubTeamsPage from '../../../../players/ClubTeamsPage.tsx';

export const Route = createFileRoute('/_app/esports/teams/')({
    component: () => <ClubTeamsPage sport="esports" />,
});
